import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import {
  fDummyFunction,
  GridDataColumn,
} from "../../../Component/Common/ReuseableComponent/Action";
import {
  CmpTypographyField,
  CmpInputField,
  CmpSelectField,
  CmpButton,
  CmpDatePickerField001,
} from "../../../Component/Common/ToolBox/ToolBox";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";

const GCBatch = ({
  xOpen = false,
  GridDataBatchRows = [],
  GridDataBatchColumns = "",
  xOnRowClick,
  xBatchUnit = [],
  xTitle = "Batch setup",
  batchnoFieldEnable = false,
  xHeadSrNo = "",
  xHeadItemCode = "",
  xHeadItemName = "",
  xHeadQty = "",
  xHeadUnit = "",
  xHeadBaseQty = "",
  xDetailSrNo = "",
  xDetailBatchNo = "",
  xDetailMFDate = new Date(),
  xDetailExpDate = new Date(),
  xDetailQty = "",
  xDetailUnit = "",
  xDetailBaseQty = "",
  xDetailBalanceQty = "",
  xBatch_fSrNo,
  xBatch_fBatchNo,
  xBatch_fMFDate,
  xBatch_fExpDate,
  xBatch_fQty,
  xBatch_fUnit,
  xBatch_fBaseQty,
  xfBatch_Close,
  xfBatch_New,
  xfBatch_Delete,
  xfBatch_Save,
  xBtnDisable = false,
  xErrorMsg,
  xfBatch_Focus_Qty,
  xfBatch_Blur_Qty,
  xTotalQty,
  batch = true,
  xBatchNo_focus,
  xBatchNo_blur,
}) => {
  const vMediaQuery = useMediaQuery("(max-width:850px)");
  return (
    <Modal
      open={xOpen}
      // onClose={fBatch_CloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ flexGrow: 1, overflow: "auto" }} className="model-GCbatch ">
        <GCTitleSticky title={xTitle} onClose={xfBatch_Close} />

        <Grid
          container
          spacing={0}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          className="GCbatch-m"
        >
          <Grid item xs={11} sm={11} md={11} lg={11}>
            <CmpTypographyField
              xcomponent={"h1"}
              xText={xTitle}
              xfontSize="20px"
              xtextDecoration="underline"
            />
          </Grid>
          {/* <Grid item xs={1} sm={1} md={1} lg={1} className="text-end">
          <CmpButtonKIcon
            xOnClick={!!xfBatch_Close ? xfBatch_Close : fDummyFunction}
            xDisabled={false}
            xIcon={<CloseIcon fontSize={"medium"} />}
          />
        </Grid> */}
        </Grid>
        <div className="p-2">
          <Grid container spacing={0} columns={{ xs: 24, sm: 24, md: 36 }}>
            <Grid item xs={3} sm={3} md={3}>
              <CmpTypographyField xcomponent={"div"} xText={"Sr.No"} />
            </Grid>
            <Grid item xs={9} sm={9} md={9}>
              <CmpTypographyField xcomponent={"div"} xText={": " + xHeadSrNo} />
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <CmpTypographyField xcomponent={"div"} xText={"Item Code"} />
            </Grid>
            <Grid item xs={9} sm={9} md={9} lg={10}>
              <CmpTypographyField
                xcomponent={"div"}
                xText={": " + xHeadItemCode}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <CmpTypographyField xcomponent={"div"} xText={"Item Name:"} />
            </Grid>
            <Grid item xs={9} sm={9} md={9} lg={10}>
              <CmpTypographyField
                xcomponent={"div"}
                xText={": " + xHeadItemName}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <CmpTypographyField xcomponent={"div"} xText={"Qty:"} />
            </Grid>
            <Grid item xs={9} sm={9} md={9}>
              <CmpTypographyField xcomponent={"div"} xText={": " + xHeadQty} />
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <CmpTypographyField xcomponent={"div"} xText={"Unit:"} />
            </Grid>
            <Grid item xs={9} sm={9} md={9}>
              <CmpTypographyField xcomponent={"div"} xText={": " + xHeadUnit} />
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <CmpTypographyField xcomponent={"div"} xText={"BaseQty:"} />
            </Grid>
            <Grid item xs={9} sm={9} md={9}>
              <CmpTypographyField
                xcomponent={"div"}
                xText={": " + xHeadBaseQty}
              />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className="GCbatch-m"
          >
            <Grid item xs={4} sm={4} md={11} lg={11}>
              <CmpTypographyField
                xcomponent={"div"}
                xText={batch ? "Batch Detail" : "Serial Detail"}
                xfontSize="20px"
                xtextDecoration="underline"
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          >
            <Grid item xs={2} sm={2} md={1} lg={1}>
              <CmpTypographyField xcomponent={"div"} xText={"Sr.No"} />
              <CmpInputField
                xValue={xDetailSrNo}
                xType={"number"} // text/number/password
                xName={"BatchDetail_SrNo"}
                xReadOnly={true}
                xOnChange={!!xBatch_fSrNo ? xBatch_fSrNo : fDummyFunction}
                xError={xErrorMsg.BatchDetail_SrNo === "" ? false : true}
                xErrorMessage={xErrorMsg.BatchDetail_SrNo}
                xOnKeyUp={""}
              />
            </Grid>
            <Grid item xs={2} sm={3} md={"auto"} lg={"auto"}>
              <CmpTypographyField
                xcomponent={"div"}
                xText={batch ? "Batch No" : "Serial No"}
              />
              <CmpInputField
                xValue={xDetailBatchNo}
                xType={"text"} // text/number/password
                xName={"BatchDetail_BatchNo"}
                xReadOnly={batchnoFieldEnable}
                xOnChange={!!xBatch_fBatchNo ? xBatch_fBatchNo : fDummyFunction}
                xError={xErrorMsg.BatchDetail_BatchNo === "" ? false : true}
                xErrorMessage={xErrorMsg.BatchDetail_BatchNo}
                xOnKeyUp={""}
                xtabIndex={"1001"}
                xonFocus={xBatchNo_focus}
                xonBlur={xBatchNo_blur}
              />
            </Grid>
            <Grid item xs={4} sm={3} md={"auto"} lg={"auto"}>
              <CmpTypographyField xcomponent={"div"} xText={"MF.Date"} />
              <CmpDatePickerField001
                xtabIndex={"1002"}
                xValue={xDetailMFDate}
                xOnChange={!!xBatch_fMFDate ? xBatch_fMFDate : fDummyFunction}
                xName={"BatchDetail_MFDate "}
                xError={xErrorMsg.BatchDetail_MFDate === "" ? false : true}
                xErrorMessage={xErrorMsg.BatchDetail_MFDate}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>
            <Grid item xs={4} sm={3} md={"auto"} lg={"auto"}>
              <CmpTypographyField xcomponent={"div"} xText={"Exp.Date"} />
              <CmpDatePickerField001
                xtabIndex={"1003"}
                xValue={xDetailExpDate}
                xmindate={xDetailMFDate}
                xOnChange={!!xBatch_fExpDate ? xBatch_fExpDate : fDummyFunction}
                xName={"BatchDetail_ExpDate"}
                xError={xErrorMsg.BatchDetail_ExpDate === "" ? false : true}
                xErrorMessage={xErrorMsg.BatchDetail_ExpDate}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>
            <Grid item xs={2} sm={2} md={1} lg={1}>
              <CmpTypographyField xcomponent={"div"} xText={"Qty"} />
              <CmpInputField
                xtabIndex={"1004"}
                xValue={xDetailQty}
                xType={"number"} // text/number/password
                xName={"BatchDetail_Qty"}
                xReadOnly={false}
                xOnChange={!!xBatch_fQty ? xBatch_fQty : fDummyFunction}
                xError={xErrorMsg.BatchDetail_Qty === "" ? false : true}
                xErrorMessage={xErrorMsg.BatchDetail_Qty}
                xOnKeyUp={""}
                xonFocus={xfBatch_Focus_Qty}
                xonBlur={xfBatch_Blur_Qty}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpTypographyField xcomponent={"div"} xText={"Unit"} />
              <CmpSelectField
                xtabIndex={"1005"}
                xLabelText="Unit"
                xValue={xDetailUnit}
                xOnChange={!!xBatch_fUnit ? xBatch_fUnit : fDummyFunction}
                xName={"BatchDetail_Unit"}
                xData={xBatchUnit}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.BatchDetail_Unit === "" ? false : true}
                xErrorMessage={xErrorMsg.BatchDetail_Unit}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={2} sm={2} md={1} lg={1}>
              <CmpTypographyField xcomponent={"div"} xText={"BaseQty"} />
              <CmpInputField
                xtabIndex={"1006"}
                xValue={xDetailBaseQty}
                xType={"number"} // text/number/password
                xName={"BatchDetail_BaseQty"}
                xReadOnly={true}
                xOnChange={!!xBatch_fBaseQty ? xBatch_fBaseQty : fDummyFunction}
                xError={xErrorMsg.BatchDetail_BaseQty === "" ? false : true}
                xErrorMessage={xErrorMsg.BatchDetail_BaseQty}
                xOnKeyUp={""}
              />
            </Grid>
            <Grid item xs={2} sm={2} md={1} lg={1}>
              <CmpTypographyField xcomponent={"div"} xText={"BalanceQty"} />
              <CmpInputField
                xValue={xDetailBalanceQty}
                xType={"number"} // text/number/password
                xName={"BatchDetail_BalanceQty"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xOnKeyUp={""}
              />
            </Grid>
            {/* <Grid item xs={3} sm={3} md={1.5} lg={1}>
          <CmpTypographyField xcomponent={"div"} xText={"Attribute1"} />
          <CmpInputField
            xValue={xDetailAttribute1}
            xType={"text"} // text/number/password
            xName={"xDetailAttribute1"}
            xReadOnly={true}
            xOnChange={
              !!xBatch_fAttribute1 ? xBatch_fAttribute1 : fDummyFunction
            }
            xError={false}
            xErrorMessage={""}
            xOnKeyUp={""}
          />
        </Grid>
        <Grid item xs={3} sm={3} md={1.5} lg={1}>
          <CmpTypographyField xcomponent={"div"} xText={"Attribute2"} />
          <CmpInputField
            xValue={xDetailAttribute2}
            xType={"text"} // text/number/password
            xName={"xDetailAttribute2"}
            xReadOnly={true}
            xOnChange={
              !!xBatch_fAttribute2 ? xBatch_fAttribute2 : fDummyFunction
            }
            xError={false}
            xErrorMessage={""}
            xOnKeyUp={""}
          />
        </Grid>
        <Grid item xs={3} sm={3} md={1.5} lg={1}>
          <CmpTypographyField xcomponent={"div"} xText={"Attribute3"} />
          <CmpInputField
            xValue={xDetailAttribute3}
            xType={"text"} // text/number/password
            xName={"xDetailAttribute3"}
            xReadOnly={true}
            xOnChange={
              !!xBatch_fAttribute3 ? xBatch_fAttribute3 : fDummyFunction
            }
            xError={false}
            xErrorMessage={""}
            xOnKeyUp={""}
          />
        </Grid> */}
          </Grid>

          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className="GCbatch-m"
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div id="table-Batch" className="GCBatch-grid-table ">
                <Box
                  style={{
                    height: vMediaQuery ? "30vh" : "35vh",
                    width: "100%",
                  }}
                  className="GCBranch-grid"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    rows={GridDataBatchRows}
                    columns={
                      !!GridDataBatchColumns
                        ? GridDataBatchColumns
                        : GridDataColumn
                    }
                    getRowId={(row) => row.id}
                    hideFooter={GridDataBatchRows.length < 100}
                    // // onColumnHeaderEnter={}
                    // onCellKeyDown={xOnCellKeyDown}
                    onRowClick={!!xOnRowClick ? xOnRowClick : fDummyFunction}
                    components={{
                      Toolbar: GridToolbar,
                    }}
                  />
                </Box>
              </div>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            justifyContent="end"
            alignItems="center"
          >
            <Grid item xs={"auto"} sm={"auto"} md={"auto"} lg={"auto"}>
              <CmpTypographyField xcomponent={"div"} xText={"Total Base_Qty"} />
            </Grid>
            <Grid item xs={"auto"} sm={"auto"} md={"auto"} lg={"auto"}>
              <CmpInputField
                xValue={xTotalQty}
                xType={"text"} // text/number/password
                xName={"sBatch_Total_Qty"}
                xReadOnly={true}
                xOnChange={!!xBatch_fSrNo ? xBatch_fSrNo : fDummyFunction}
                xError={false}
                xErrorMessage={""}
                xOnKeyUp={""}
                xTextAlign="end"
              />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className="GCbatch-m"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={"auto"} sm={"auto"} md={"auto"} lg={"auto"}>
              <CmpButton
                xbtnName="New"
                xOnClick={!!xfBatch_New ? xfBatch_New : fDummyFunction}
                xVariant="contained"
                xDisabled={xBtnDisable}
                xSize="small"
              />
            </Grid>
            <Grid item xs={"auto"} sm={"auto"} md={"auto"} lg={"auto"}>
              <CmpButton
                xbtnName="Save"
                xOnClick={!!xfBatch_Save ? xfBatch_Save : fDummyFunction}
                xVariant="contained"
                xDisabled={xBtnDisable}
                xSize="small"
              />
            </Grid>
            <Grid item xs={"auto"} sm={"auto"} md={"auto"} lg={"auto"}>
              <CmpButton
                xbtnName="Delete"
                xOnClick={
                  !!xfBatch_Delete && xDetailSrNo != 0
                    ? xfBatch_Delete
                    : fDummyFunction
                }
                xVariant="contained"
                xDisabled={xBtnDisable}
                xSize="small"
              />
            </Grid>
            {/* <Grid item xs={4} sm={4} md={2} lg={"auto"}>
              <CmpButton
                xbtnName="Delete All"
                xOnClick={""}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
              />
            </Grid> */}
            <Grid item xs={"auto"} sm={"auto"} md={"auto"} lg={"auto"}>
              <CmpButton
                xbtnName="Close"
                xOnClick={!!xfBatch_Close ? xfBatch_Close : fDummyFunction}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
              />
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};
export default GCBatch;
